import { makeStyles } from '@material-ui/core/styles';

const AdminStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    error: {
        color: theme.palette.error.main
    },
    heading: {
        borderBottom: '1px solid ' + theme.palette.primary.main
    },

    selectedButton: {
        background: theme.palette.primary.dark
    },
    picker: {
        "& .MuiTypography-body2": {
            marginTop: '0',
        },
        "& .MuiTypography-subtitle1": {
            marginTop: theme.spacing(2), 
            marginBottom: theme.spacing(0)
        }
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#ffffffaa'
    },
    tablePaging: {
        "& .MuiTablePagination-input": {
            marginTop: theme.spacing(3)
        }
    },
    switchLabel: {
        "& .MuiFormControlLabel-label": {
             marginBottom: theme.spacing(0),
  
        }
    },
    errorDismissButton: {
        "& .MuiButton-label": {
            color: "#fff"
        }
    },
    accordion: {
        "& .MuiAccordionSummary-content h4": {
            fontWeight: "bold",
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1),
        },
        "& .MuiAccordionDetails-root": {
            display: "block",
        }
    }, 
    domainList: {
        "& .MuiListItemText-primary": {
            marginTop: theme.spacing(1),
            marginBottom: 0
        }
    },
    formGrid: {
        marginTop: theme.spacing(1),
    },
    disabled: {
        backgroundColor: theme.palette.grey.light,
     
    }
}));

export default AdminStyles;